export const canvasDetailsActions = {
    startLoader: "START_UPDATE_CANVAS_DETAILS_LOADER",
    request: "REQUEST_CANVAS_DETAILS",
    update: "UPDATE_CANVAS_DETAILS",
    success: "UPDATE_CANVAS_DETAILS_SUCESS",
    failure: "UPDATE_CANVAS_DETAILS_FAILURE",
    reset: "RESET_UPDATE_CANVAS_DETAILS",
};

export const getCanvasDetails = (buyplanId, recipent, subject, body) => {
    return {
        type: canvasDetailsActions.request,
        payload: {
            buyplanId,
            recipent, 
            subject, 
            body
        },
    };
};

export const updateCanvasDetails = (buyplanId, canvasURL) => {
    return {
        type: canvasDetailsActions.update,
        payload: {
            buyplanId,
            canvasURL
        },
    };
};

export const getCanvasDetailsSuccess = (payload) => {
    return {
        type: canvasDetailsActions.success,
        payload,
    };
};

export const getCanvasDetailsFailure = (errorPayload) => {
    return {
        type: canvasDetailsActions.failure,
        payload: errorPayload,
    };
};
